module.exports = __webpack_public_path__ + "img/women.fe6e6701.png";